import { AfterContentInit, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { count, from, map, of, reduce } from 'rxjs';
import { FileServiceService } from '../service/file-service.service';
import { FileCaptureService } from 'app/service/file-capture.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-review-files',
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './review-files.component.html',
  styleUrls: ['./review-files.component.css']
})
export class ReviewFilesComponent implements OnInit {
  files: any;
  totalFilesSize: number = 0;
  isDisabled: boolean;
  FilesToUpload: any = [];
  BufferChunkSize: any;
  fileUploadMap: any = {};
  totalUploadedFiles: any = 0;
  canUpload: boolean = true;
  hasUpdate: boolean;
  uploadedFiles: File[] | null = null;
  fileSubmitted: boolean = false;
  showFileUploadError: boolean;

  constructor(
    private route: Router,
    public service: FileServiceService,
    private fcservice: FileCaptureService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone,
    private ngxspinner : NgxSpinnerService
  ) {
   
  }

ngOnInit() {
  this.service.setPageVisited('review-files');
  if (this.service.getCache('files')) {
    this.files = this.service.getCache('files');
    from(this.files.map((x: any) => x.fileSize))
      .pipe(reduce((a: any, b: any) => a + b, 0))
      .subscribe(x => this.totalFilesSize = x);
    this.service.referenceFileDetails.files = this.files;
    this.uploadedFiles = this.fcservice.fileArray;

    this.isDisabled = this.files == null || this.files.length < 1;
  }
}

  reviewAndScan() {
    setTimeout(() => {
      const attachment = {
        referenceId: '',
        attachmentKeyList: []
      };
      attachment.referenceId = this.service.getCache('referenceId');
      attachment.attachmentKeyList = this.files.map(x => x.attachmentKey);
      if (attachment.attachmentKeyList.length > 0) {
        this.fcservice.ReviewAndScanAttachmnents(attachment).subscribe(
          (result: boolean) => {
            console.log(result);
          },
          (error: any) => {
            console.log(error);
          }
        );
      }
    }, 3000);
  }

  next() {
    this.route.navigate(['initiate-download']);
  }

  removeFile(index: number) {
    this.totalFilesSize = this.totalFilesSize - this.files[index].fileSize;
    this.files.splice(index, 1);
    this.service.setCacheForitems([{ id: "files", value: this.files }]);
    const newFiles = this.files.filter(x => x.isUpload == 1)
    if (newFiles == 0 && this.files.length > 0) {
      this.isDisabled = false;
    }
  }

  addNewFile() {
    this.route.navigate(['file-upload']);
  }

  back() {
    this.route.navigate(['file-upload']);
  }

  async uploadFirstFile(firstFile: any) {
    const attachment = {
      fileName: firstFile.fileName.substring(firstFile.fileName.lastIndexOf('\\') + 1),
      fileType: firstFile.fileName.substring(firstFile.fileName.lastIndexOf('.') + 1),
      percentage: 0,
      fileSize: firstFile.fileSize || 0,
      sizeReadable: 0,
      isFirst: true,
      fileId: 0,
      activityName: 'Deconfliction',
      referenceId: this.service.getCache('referenceId'),
      targetFile: this.uploadedFiles?.find(x => x.name == firstFile.fileName),
      attachmentLength: firstFile.fileSize,
      noOfchunksSent:0
    };

    this.FilesToUpload.push(attachment);
    return new Promise((resolve, reject) => {
      this.fcservice.addAttachmentToDB(attachment).subscribe({
        next: (data: any) => {
          if (data.attachmentKey === -1 || data.attachmentKey === 0) {
            this.FilesToUpload = [];
            const index = this.files.findIndex(x => x.fileName === this.FilesToUpload[0].fileName);
            if (index > -1) {
              this.files[index].attachmentKey = data.attachmentKey;
              this.files[index].isFirst = false;
              this.files[index].isUpload = 0;
              this.files[index].isVisible = data.attachmentKey + "_99";
              this.service.setCacheForitems([{ id: "files", value: this.files }]);
            }
            reject('Invalid attachment key');
          } else {
            this.service.referenceFileDetails.caseActivityKey = data.caseActivityKey;
            this.service.setCacheForitems([
              { id: "caseActivityKey", value: data.caseActivityKey },
              { id: "attachmentSaved", value: "Saved" }
            ]);

            this.FilesToUpload[0].attachmentKey = data.attachmentKey;
            if (attachment.isFirst) {
              this.service.referenceFileDetails.caseActivityKey = data.caseActivityKey;
              this.service.setCacheForitems([{ id: "caseActivityKey", value: data.caseActivityKey }]);
            }

            const index = this.files.findIndex(x => x.fileName === this.FilesToUpload[0].fileName);
            if (index > -1) {
              this.files[index].attachmentKey = data.attachmentKey;
              this.files[index].isFirst = false;
              this.files[index].isUpload = 0;
              this.files[index].isVisible = data.attachmentKey + "_0";
              this.service.setCacheForitems([{ id: "files", value: this.files }]);
            }
            this.processFiles(attachment.fileId);
            resolve(data);
          }
        },
        error: (err) => {
          console.error('Error uploading first file:', err);
          reject(err);
        }
      });
    });
  }

  async uploadFiles(files: any) {
    for (let i = 0; i < files.length; i++) {
      const attachment = {
        fileName: files[i].fileName.substring(files[i].fileName.lastIndexOf('\\') + 1),
        fileType: files[i].fileName.substring(files[i].fileName.lastIndexOf('.') + 1),
        percentage: 0,
        fileSize: files[i].fileSize || 0,
        sizeReadable: 0,
        isFirst: false,
        fileId: i + 1, // Offset fileId to avoid collision with first file
        activityName: 'Deconfliction',
        referenceId: this.service.getCache('referenceId'),
        targetFile: this.uploadedFiles?.find(x => x.name == files[i].fileName),
        attachmentLength: files[i].fileSize,
        noOfchunksSent:0
      };

      this.FilesToUpload.push(attachment);
      this.addAttachmentToDb(attachment, attachment.targetFile, attachment.fileId);
    }
  }

  addAttachmentToDb(attachment, targetFile, i) {
    var getFileIndex = this.FilesToUpload.findIndex(x => x.fileId === i);
    this.FilesToUpload[getFileIndex].attachmentLength = attachment.fileSize;
    this.FilesToUpload[getFileIndex].targetFile = targetFile;
    this.FilesToUpload[getFileIndex].referenceId = this.service.getCache('referenceId');

    this.fcservice.addAttachmentToDB(attachment).subscribe({
      next: (data: any) => {
        if (data.attachmentKey === -1 || data.attachmentKey === 0) {
          const index = this.files.findIndex(x => x.fileName === this.FilesToUpload[getFileIndex].fileName);
            if (index > -1) {
              this.files[index].attachmentKey = data.attachmentKey;
              this.files[index].isFirst = false;
              this.files[index].isUpload = 0;
              this.files[index].isVisible = data.attachmentKey + "_99";
              this.service.setCacheForitems([{ id: "files", value: this.files }]);
            }
          const idx = this.FilesToUpload.findIndex(x => x.fileId === i);
          if (idx > -1) {
            this.FilesToUpload.splice(idx, 1);
          }
        } else {
          const idx = this.FilesToUpload.findIndex(x => x.fileId === i);
          if (idx > -1) {
            this.FilesToUpload[idx].attachmentKey = data.attachmentKey;
            if (attachment.isFirst) {
              this.service.referenceFileDetails.caseActivityKey = data.caseActivityKey;
              this.service.setCacheForitems([{ id: "caseActivityKey", value: data.caseActivityKey }]);
            }

            const index = this.files.findIndex(x => x.fileName === this.FilesToUpload[idx].fileName);
            if (index > -1) {
              this.files[index].attachmentKey = data.attachmentKey;
              this.files[index].isFirst = false;
              this.files[index].isUpload = 0;
              this.files[index].isVisible = data.attachmentKey + "_0";
              this.service.setCacheForitems([{ id: "files", value: this.files }]);
            }
            this.processFiles(i);
          }
        }
      },
      error: (err) => {
        console.error('Error adding attachment to DB:', err);
      }
    });
  }

  processFiles(i) {
    var getFileIndex = this.FilesToUpload.findIndex(x => x.fileId === i);
    if (this.FilesToUpload[getFileIndex].attachmentKey && Math.abs(parseInt(this.FilesToUpload[getFileIndex].fileSize)) >= 1024 * 1024 * 50) {
      this.createandUploadChunks(this.FilesToUpload[getFileIndex], this.FilesToUpload[getFileIndex].targetFile, i);
      this.nextBatchProcess(i);

    }
    else {
      this.upload(this.FilesToUpload[getFileIndex].targetFile, i, null, this.FilesToUpload[getFileIndex].fileSize, this.FilesToUpload[getFileIndex].fileName,
        0, this.FilesToUpload[getFileIndex].attachmentKey, i);
    }
  }

  createandUploadChunks(attachment, targetFile, i) {
    var fileChunks = [];
    var Size = attachment.fileSize;
    var num = (1024 * 1024) * 50;
    if (Size / num > 256) {
      this.BufferChunkSize = Size / 256;
    }
    else
      this.BufferChunkSize = (1024 * 1024) * 50;
    var ReadBuffer_Size = 1024;
    var FileStreamPos = 0;
    var EndPos = this.BufferChunkSize;

    var fileChunkId = 0;
    while (FileStreamPos < Size) {
      fileChunks.push({ targetFile: targetFile.slice(FileStreamPos, EndPos), id: fileChunkId });
      FileStreamPos = EndPos;
      EndPos = FileStreamPos + this.BufferChunkSize;
      fileChunkId++;
    }
    var getFileIndex = this.FilesToUpload.findIndex(x => x.fileId === i);

    this.FilesToUpload[getFileIndex].fileChunksLength = fileChunks.length;
    this.FilesToUpload[getFileIndex].fileChunks = fileChunks;
    this.FilesToUpload[getFileIndex].lastFileChunkId = fileChunkId;
  }

  nextBatchProcess(i) {
    var getFileIndex = this.FilesToUpload.findIndex(x => x.fileId === i);
    var remainder = this.FilesToUpload[getFileIndex].fileChunksLength % 5;
    var num = 5;
    var total = this.FilesToUpload[getFileIndex].fileChunks.length;
    if (total === remainder || total < 5) {
      num = this.FilesToUpload[getFileIndex].fileChunks.length;
    }

    for (var countChunk = 0; countChunk < total; countChunk++) {
      if (this.FilesToUpload[getFileIndex].fileChunks[countChunk] != null) {
        this.upload(this.FilesToUpload[getFileIndex].fileChunks[countChunk].targetFile,
          this.FilesToUpload[getFileIndex].fileChunks[countChunk].id,
          null,
          this.FilesToUpload[getFileIndex].fileSize,
          this.FilesToUpload[getFileIndex].fileName,
          this.FilesToUpload[getFileIndex].fileChunksLength,
          this.FilesToUpload[getFileIndex].attachmentKey,
          i
        );
      }
    }
  }

  upload(chunk, chunkorfileId, objXhr1, fileSize, fileName, totalChunks, attachmentKey, itemindex) {
    try {
      if (fileSize <= (1024 * 1024 * 50)) {
        chunkorfileId = this.FilesToUpload.findIndex(x => x.fileId === chunkorfileId);
      }
      var baseUrl = environment.baseUri;
      if(this.service.getCache('caseActivityKey')){
        this.service.referenceFileDetails.caseActivityKey = this.service.getCache('caseActivityKey');
      }
      var url =
        baseUrl + "FileCapture/UploadAttachment?attachmentKey=" + attachmentKey + "&referenceId=" + this.service.referenceFileDetails.referenceId + "&caseactivitykey=" + this.service.referenceFileDetails.caseActivityKey;

      var objXhr;
      objXhr = new XMLHttpRequest();
      var data = new FormData();

      data.append('uploadedFile', chunk);
      objXhr.upload.fileId = chunkorfileId;
      objXhr.upload.fileName = fileName;

      objXhr.timeout = 3600000;
      objXhr.open('POST', url);

      objXhr.setRequestHeader("X-Content-Name", fileName);
      objXhr.setRequestHeader("Ocp-Apim-Subscription-Key", environment.subscriptionKey);
      //if its a small file no need for custom headers
      if (totalChunks !== 0) {

        objXhr.setRequestHeader("X-Chunk-Id", chunkorfileId);
        // objXhr.setRequestHeader("X-Content-Id", tokenResult.token);
        objXhr.setRequestHeader("X-Content-Length", fileSize);
        objXhr.setRequestHeader("X-Total-Chunks", totalChunks);

        if (chunkorfileId === totalChunks - 1) {
          objXhr.setRequestHeader("X-Last-Chunk", true);
        }
        else
          objXhr.setRequestHeader("X-Last-Chunk", false);
      }

      if (fileSize <= (1024 * 1024 * 50)) {
        this.FilesToUpload[chunkorfileId].xmlObj = objXhr;
        objXhr.upload.addEventListener("progress", (evt) => this.updateProgressForSmallFiles(evt), false);
      }
      else
        objXhr.upload.addEventListener("progress", (evt) => this.updateProgress(evt), false);


      objXhr.onload = () => {
        if (objXhr.status >= 200 && objXhr.status < 300) {
          this.zone.run(() => {
            if (fileSize > (1024 * 1024 * 50)) {
              if (this.fileUploadMap[attachmentKey] === undefined) {
                this.fileUploadMap[attachmentKey] = 1;
              } else {
                this.fileUploadMap[attachmentKey]++;
              }
              if (totalChunks === this.fileUploadMap[attachmentKey]) {
                //this.isDisabled = false;   
                this.totalUploadedFiles++;
                this.fcservice.commitFile(attachmentKey, fileName, totalChunks).subscribe(
                  (data: any) => {

                  });

              }
            } else {
              this.totalUploadedFiles++;
            }

            if (this.totalUploadedFiles == this.files.length) {
              this.isDisabled = false;
            }

          });
        }
      }
      objXhr.send(data);
    }
    catch (e) {
        var result = (e as Error).message as String;
        if (result.includes('String contains non ISO-8859-1 code point')) {
          this.files.forEach(item => {
            if(item.fileName == fileName) {
              item.isVisible = item.attachmentKey + '_99';
            }
          });
        }
    }
  }

  updateProgressForSmallFiles(e) {
    var filename = e.currentTarget.fileName;
    let keyOfFilesmall;
    this.FilesToUpload.forEach((value, key) => {
      if (value.fileName === filename)
        keyOfFilesmall = key;
    });
    this.zone.run(() => {
      var percent = 100;
      this.FilesToUpload[keyOfFilesmall].percentage = percent.toFixed(0);
      this.FilesToUpload[keyOfFilesmall].isReadyToDownload = true;
      let index = this.files.findIndex(x => x.fileName === this.FilesToUpload[keyOfFilesmall].fileName);
      if (index > -1) {
        this.files[index].percentage = parseInt(percent.toFixed(0));
        this.files[index].isReadyToDownload = true; 
      }
      const attachment = {
        referenceId: '',
        attachmentKeyList: []
      };
      attachment.referenceId = this.service.getCache('referenceId');
      attachment.attachmentKeyList = this.files.map(x =>{
        if(x.attachmentKey != null && typeof(x.attachmentKey) !== 'undefined' && x.isVisible != x.attachmentKey + '_99'){
          return x.attachmentKey
        }
      });
      this.fcservice.pollStatus(5000, attachment).subscribe(status => {
        if (status) {
          console.log('Condition met, stopping polling.');
          this.files.forEach((item) => {
            if (status.filter(y => y.id == item.attachmentKey).length) {
              item.isVisible = (item.attachmentKey + "_" + status.filter(y => y.id == item.attachmentKey)[0].VirusScanStatus);
              this.isDisabled = this.files.filter(x => x.isVisible == (x.attachmentKey + "_0")).length > 0;
            }
          });
          this.service.setCacheForitems([{ id: "files", value: this.files }]);
          this.cdr.markForCheck();
        } else {
          console.log('Condition not met, polling continues.');
        }
      });
      this.hasUpdate = true;
    });
  }

  updateProgress(e) {
    var chunkid = e.currentTarget.fileId;
    var filename = e.currentTarget.fileName;

    let keyOfFile;

    this.FilesToUpload.forEach((value, key) => {
      if (value.fileName === filename) {
        keyOfFile = key;
      }
    });

    this.zone.run(() => {
      var perc = ((this.FilesToUpload[keyOfFile].noOfchunksSent * this.BufferChunkSize) / this.FilesToUpload[keyOfFile].fileSize) * 100;
      if (perc < 100)
        this.FilesToUpload[keyOfFile].percentage = perc.toFixed(0);
      else if (perc >= 100 && this.FilesToUpload[keyOfFile].fileChunksLength === this.FilesToUpload[keyOfFile].noOfchunksSent) {
        this.FilesToUpload[keyOfFile].isReadyToDownload = true;
        this.FilesToUpload[keyOfFile].percentage = 100;
        let index = this.files.findIndex(x => x.fileName === this.FilesToUpload[keyOfFile].fileName);
        if (index > -1) {
          this.files[index].percentage = parseInt(perc.toFixed(0));
          this.files[index].isReadyToDownload = true; 
        }   
        this.service.setCacheForitems([{ id: "files", value: this.files }]);
        this.hasUpdate = true;
      }
    });

    var remainder = this.FilesToUpload[keyOfFile].fileChunksLength % 5;

    
    var idx = this.FilesToUpload[keyOfFile].fileChunks.findIndex(function (x) {
      return x.id === chunkid;
    });

    if (idx > -1) {
      this.FilesToUpload[keyOfFile].fileChunks.splice(idx, 1);
      this.FilesToUpload[keyOfFile].noOfchunksSent++;
    }

    if (this.FilesToUpload[keyOfFile].fileChunksLength === this.FilesToUpload[keyOfFile].noOfchunksSent) {
      if (this.FilesToUpload[keyOfFile].isReadyToDownload === true) {
        var percent = 100;
        this.FilesToUpload[keyOfFile].percentage = percent.toFixed(0);
        this.FilesToUpload[keyOfFile].isReadyToDownload = true;
        let index = this.files.findIndex(x => x.fileName === this.FilesToUpload[keyOfFile].fileName);
        if (index > -1) {
          this.files[index].percentage = parseInt(percent.toFixed(0));
          this.files[index].isReadyToDownload = true; 
        }  
        this.service.setCacheForitems([{ id: "files", value: this.files }]);
        const attachment = {
        referenceId: '',
        attachmentKeyList: []
      };
      attachment.referenceId = this.service.getCache('referenceId');
      attachment.attachmentKeyList = this.files.map(x => {
        if(x.attachmentKey != null && typeof(x.attachmentKey) !== 'undefined' && x.isVisible != x.attachmentKey + '_99'){
          return x.attachmentKey;
        }
      });
      this.fcservice.pollStatus(5000, attachment).subscribe(status => {
        if (status) {
          console.log('Condition met, stopping polling.');
          this.files.forEach((item) => {
            if (status.filter(y => y.id == item.attachmentKey).length) {
              item.isVisible = (item.attachmentKey + "_" + status.filter(y => y.id == item.attachmentKey)[0].VirusScanStatus);
              this.isDisabled = this.files.filter(x => x.isVisible == (x.attachmentKey + "_0")).length > 0;
            }
          });
          this.service.setCacheForitems([{ id: "files", value: this.files }]);
          this.cdr.markForCheck();
        } else {
          console.log('Condition not met, polling continues.');
        }
      });        
      }
    }
  }

  
  async onSubmit() {
    if (this.service.referenceFileDetails.files.length > 0) {
      const newFiles = this.files.filter(x => x.isUpload == 1);
      if (newFiles.length > 0) {
        this.isDisabled = true;
        if (!this.service.getCache('attachmentSaved')) {
          // Upload only the first file
          await this.uploadFirstFile(newFiles[0]);
          // After first file is uploaded, upload remaining files
          const remainingFiles = newFiles.slice(1);
          if (remainingFiles.length > 0) {
            this.uploadFiles(remainingFiles);
          }
        } else {
          // If attachmentSaved exists, upload all new files
          await this.uploadFiles(newFiles);
        }


        this.files.forEach((item: any) => {
          if (!item.isVisible) {
            item.isVisible = item.attachmentKey + "_0";
          }
        });
      }
      
        let uploadInterval = setInterval(() => {

          let allFilesUploaded: boolean = true;
          this.service.referenceFileDetails.files.forEach((item: any) => {
            if (item.attachmentKey == null) {
              allFilesUploaded = false;
            }
          });
          if(allFilesUploaded) {
            clearInterval(uploadInterval);

            let data = {
              BusinessName : this.service.referenceFileDetails.businessName,
              ContactName : this.service.referenceFileDetails.contactName,
              ContactPhone : this.service.referenceFileDetails.contactPhone,
              ContactEmail : this.service.referenceFileDetails.contactEmail,
              ReferenceId : this.service.referenceFileDetails.referenceId,
              CaseActivityKey : this.service.referenceFileDetails.caseActivityKey,
              ActiveAttachmentKey: this.service.referenceFileDetails.files.filter((x: any) => {
                if(x.isVisible != x.attachmentKey + '_99') {
                  return x;
                }
              }).map((x: any) => x.attachmentKey)

            };

            this.ngxspinner.show();
            this.fcservice.submitDocument(data).subscribe((res) => {
              this.fileSubmitted = true;
              this.ngxspinner.hide();
              let invalidFilePresent: boolean = false;
              this.files.forEach(item => {
                if(item.isVisible == item.attachmentKey + "_99") {
                  invalidFilePresent = true;
                }
              });

              if(invalidFilePresent) {
                this.showFileUploadError = true;
                this.isDisabled = false;
              }
              else {
                this.showFileUploadError = false;
              }

              if(res && !invalidFilePresent) {
                this.route.navigate(['confirmation']); 
              }
              

            }, error => {this.ngxspinner.hide()});
          }
        }, 1000);
    }
  }
}
